module.exports = __webpack_public_path__ + "assets/images/printbda060919a75c017e46a96cd66f1ea57.svg";